import Form from "./Form";

const UploadPage = () => {
  return (
    <section className="h-full flex flex-col space-y-3 lg:space-y-5">
      <Form />
    </section>
  );
};

export default UploadPage;
